import { getPhaseFromPhaseList } from '@modules/trials/helpers/getPhaseFromPhaseList'
import { getPrimaryConditionFromTrial } from '@modules/trials/helpers/getPrimaryConditionFromTrial'
import getPrimaryTreatmentNameFromTrial from '@modules/trials/helpers/getPrimaryTreatmentNameFromTrial'
import { type TrialAssociation } from '@modules/trials/types/TrialAssociation'
import type { ImageCategory } from '@prisma/client'

export const getAltTextForTrialImage = (
  category: ImageCategory,
  trial: TrialAssociation,
) => {
  const primaryCondition = getPrimaryConditionFromTrial(trial)
  const armGroupNames = trial.armGroups?.map((armGroup) => armGroup.label)
  const trialPhase = getPhaseFromPhaseList(trial.phaseList)
  const treatments = trial.treatments?.filter((t) => t.isPrimary) ?? []
  const primaryTreatmentName =
    treatments[0]?.name ?? getPrimaryTreatmentNameFromTrial(trial)
  const primaryTreatmentClass = treatments[0]?.class
    ? `(${treatments[0]?.class}) `
    : ``

  switch (category) {
    case 'TrialPatientQuotes':
      return `${primaryCondition} Patient Testimony for trial: Trial Name: ${trial.nctId} — ${trialPhase}`
    case 'TrialEligibility':
      return `${primaryTreatmentName} ${primaryTreatmentClass}Clinical Trial Eligibility Overview. Trial Name: ${trial.nctId} — ${trialPhase}`
    case 'TrialAwards':
      return `${primaryCondition} Clinical Trial 2023: ${primaryTreatmentName} Highlights & Side Effects. Trial Name: ${trial.nctId} — ${trialPhase}`
    case 'TrialTimeline':
      return `${primaryTreatmentName} ${primaryTreatmentClass}2023 Treatment Timeline for Medical Study. Trial Name: ${trial.nctId} — ${trialPhase}`
    case 'TreatmentDoughnutChart':
      return `${primaryCondition} Research Study Groups: ${armGroupNames?.join(
        ', ',
      )}`
    default:
      return ''
  }
}

/**
 * Sort trial images so that they lay out nicely (wide image at the beginning and end)
 */
export const sortTrialImages = (images?: TrialAssociation['chartImages']) => {
  return images?.sort((a, b) => {
    if (a.category === 'TrialPatientQuotes') {
      return 1
    }
    if (b.category === 'TrialPatientQuotes') {
      return -1
    }
    if (a.category === 'TrialEligibility') {
      return -1
    }
    if (b.category === 'TrialEligibility') {
      return 1
    }
    return 0
  })
}
